import React, { useEffect, useState } from "react";
//import zoomSdk from "@zoom/appssdk";
import * as microsoftTeams from "@microsoft/teams-js";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import CryptoJS from "crypto-js";
import { API_BASE_URL, APP_BASE_URL, SALT_KEY } from "../utility/constants";
import AlertMsg from "./Alert";
import FooterSecuredBy from "./footerSecuredBy";
// import {  msalInstance } from "../utility/msalConfig";
import { isMacOS } from "../utility/util";
import { useMsal } from "@azure/msal-react";
//import InviteMobileModal from "./InviteMobileModal";




const PublishForm = (props) => {
  const [formpublished, setFormPublished] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [invitationerror, setInvitationError] = useState(false);
  const [isInvitationopen, setInvitationOpen] = useState(false);
  const [waitforform, setWaitForForm] = useState(false);
  // const [error1, setError1] = useState("");
  // const [error2, setError2] = useState("");
  // const [error3, setError3] = useState("");
  // const [isObocalled, setIsOBOCalled] = useState("");
  // const [teamsToken, setTeamsToken] = useState("");

  const recordindex = useSelector(
    (state) => state?.donation?.useraccountinfo || {}
  );
const teamsuserData = useSelector((state) => state?.donation?.teamsData || []);
  const formSettings = useSelector(
    (state) => state?.donation?.formSettings || {}
  );
  

  const navigate = useNavigate();
 
  const { instance, inProgress } = useMsal();

  const publish = async (e) => {
    e.preventDefault();
    setShowLoader(true);
   // setInvitationOpen(true);
    let publishData = {
      eId: props.meetingData,
      Id: recordindex.recordId,
    };
   
    let postBody = CryptoJS.AES.encrypt(
      JSON.stringify({ body: { publishData } }),
      SALT_KEY
    ).toString();
    axios
      .post(`${API_BASE_URL}`, {
        httpMethod: "POST",
        path: "/publishform",
        postBody,
      })
      .then((res) => {
        if (res.data.body) {
        
          console.log("published")
            setInvitationOpen(true);
            setShowLoader(false);
        }
      })
      .catch((err) => {
    
        if(err.toString().indexOf('denied') > -1){
          setFormPublished(true);
          navigate("/loadform", { state: { showDForm: true } });
          setShowLoader(false);
          setInvitationOpen(false);
        }else{
          setFormPublished(true);
          setInvitationError(true);
          setShowLoader(false);
          setInvitationOpen(false);
        }
       
        
      });
  };

  const reLoad = () => {
    navigate('/loadform', { state: { showDForm: true } })
  }
  

  useEffect(()=>{
     if(isInvitationopen){

       if(props.appcontext !== "web" && props.appcontext !== "desktop"){
              navigate('/minvite');
       }else{

           let urlDialogInfo = {
                      title: null,
                      height: null,
                      width: null,
                      url: null,
                      fallbackUrl: null,
                  };
                  
                  urlDialogInfo.url = `${APP_BASE_URL}/invite`;
                  urlDialogInfo.height = 400;
                  urlDialogInfo.width = 800;
                  
                  
                   microsoftTeams.dialog.url.open(urlDialogInfo,  (submitHandler) => {
                    
                    if(submitHandler.result && submitHandler.result.message){
                      if(submitHandler.result.message === "allow"){
                        console.log(`Submit handler - success:`,submitHandler.result.message);
                          setWaitForForm(true);
                          login(props.chatId, props.meetingId);
                      }
                      if(submitHandler.result.message === "deny"){
                        console.log(`Submit handler - deny:`,submitHandler.result.message);
                        setInvitationOpen(false);
                        setFormPublished(true);
                        navigate("/loadform",{ state: { showDForm: true } });
                        setShowLoader(false);
                        setWaitForForm(false);
                      }
                      
                    }
                    if(submitHandler.err){
                      console.log(`Submit handler - err:`,submitHandler.err);
                    }
                      
                     
                  });
                }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isInvitationopen]);

 

  const login = async (chatId, mId) => {
    try {
  
      
       let token = await getGraphToken(teamsuserData.email);
       const context = {
          subEntityId: "",
          chatId: props.chatId,
        };
      
       // const deeplink = `https://teams.microsoft.com/l/entity/eb3e50bb-bbbc-4815-b6ae-e861815e98c3/givent?context=${encodeURIComponent(JSON.stringify(context))}`;
        const deeplink = `https://teams.microsoft.com/l/entity/2d4b2d47-2011-4b9e-b789-dbacff73382e/givent?context=${encodeURIComponent(JSON.stringify(context))}`;


      if(token) await sendMessage(chatId, deeplink, token)
    } catch (error) {
      console.error("Login failed:", error);
       setInvitationError(true);
    }
  };



// const getGraphToken = async (userEmail) => {
//   try {
//     // Initialize Teams SDK
//     await microsoftTeams.app.initialize();

//     // Attempt silent authentication with loginHint
//     const ssoResponse = await msalInstance.ssoSilent({
//       scopes: ["ChatMessage.Send", "Chat.ReadWrite"],
//       loginHint: userEmail,  // Provide user's email for hint
//     });

//     console.log("SSO Silent Token:", ssoResponse.accessToken);
//     return ssoResponse.accessToken;
//   } catch (ssoError) {
//     console.error("SSO Silent failed:", ssoError);

//     try {
//       // Fallback to interactive login if silent fails
//       const popupResponse = await msalInstance.acquireTokenPopup({
//         scopes: ["ChatMessage.Send", "Chat.ReadWrite"],
//         loginHint: userEmail,  // Provide hint again for better UX

//       });

//       console.log("Popup acquisition success:", popupResponse.accessToken);
//       return popupResponse.accessToken;
//     } catch (popupError) {
//       try {
//          console.error("Popup token acquisition failed:", popupError);
//             await msalInstance.acquireTokenRedirect({
//                 scopes: ["ChatMessage.Send", "Chat.ReadWrite"],
//                 loginHint: userEmail,
//                 prompt: "select_account",
//               });
//               return null; // Redirect will handle the login flow
//       } catch (error) {
//          throw error;
//       }
     
     
//     }
//   }
// };

const getGraphToken = async (userEmail) => {
  try {
    await microsoftTeams.app.initialize();
   
     // Check for ongoing interaction
      if (inProgress !== "none") {
        await waitForInteractionToComplete(instance, 5000); // Wait up to 5 seconds
      }
    //const context = await microsoftTeams.app.getContext();
    //&& context?.app?.host?.clientType === "desktop"
    const isMacOs = isMacOS();
    
    // ===== 1. macOS-SPECIFIC FLOW =====
    if (isMacOs) {
       instance.clearCache();
      try {
        // A) Get Teams SSO token
        // const teamsToken = await microsoftTeams.authentication.getAuthToken();
        // setTeamsToken(teamsToken);
        // // B) Exchange for Graph token via Lambda
        // const graphToken = await getGraphTokenObo(teamsToken);
        // if (graphToken) return graphToken;
         return handleTeamsDesktopAuth(userEmail);
      } catch (teamsError) {
        console.warn("Teams SSO failed, falling back to redirect", teamsError);
        //setError3(teamsError.message);

         //return handleTeamsDesktopAuth(userEmail);
      }
    }

    // ===== 2. STANDARD FLOW (Non-macOS) =====
    try {
      // A) Try silent SSO first
      const silentToken = await instance.ssoSilent({
        scopes: ["Chat.ReadWrite", "ChatMessage.Send"],
        loginHint: userEmail,
      });
      return silentToken.accessToken;

    } catch (silentError) {
      console.warn("Silent SSO failed, trying popup", silentError);
     // setError1(silentError.message);

      // B) Fallback to popup (works on Windows/Web)
      const popupToken = await instance.acquireTokenPopup({
        scopes: ["Chat.ReadWrite", "ChatMessage.Send"],
        loginHint: userEmail,
      });
      return popupToken.accessToken;
    }

  } catch (error) {
    console.error("Auth completely failed:", error);
    //setError2(error.message);
     instance.clearCache();
    throw error;
  }
};

// const getGraphTokenObo = async(token) => {
    
//     const params = {
//                       httpMethod:'POST',
//                       path:'/getmsgtoken',
//                       body:{
//                           tId: props.userData?.accountId,
//                           token: token
//                       }
//                    };
//                      setIsOBOCalled("token==",token,"tId==",props.userData?.accountId);
//                    const response =  await axios.post(`${API_BASE_URL}`,params);
    
//                   // Check for successful response
//                   if (response.data && response.data.accessToken) {
//                     return response.data.accessToken;
//                   }
                  
//                   // Handle case where response structure is different
//                   if (response.data && response.data.body) {
//                     try {
//                       const parsedBody = JSON.parse(response.data.body);
//                       if (parsedBody.accessToken) {
//                         return parsedBody.accessToken;
//                       }
//                     } catch (e) {
//                       console.error("Error parsing response body:", e);
//                     }
//                   }
 
   
//   };

  const handleTeamsDesktopAuth = async (userEmail) => {
    try {
      const authResult = await microsoftTeams.authentication.authenticate({
        url: `${window.location.origin}/auth?teamsAuth=true&loginHint=${encodeURIComponent(userEmail)}`,
        width: 600,
        height: 600,
      });

      if (authResult.startsWith("ey")) {
        return authResult;
      }
      
      return instance.acquireTokenByCode({
        code: authResult,
        scopes: ["Chat.ReadWrite", "ChatMessage.Send"],
        redirectUri: window.location.origin + '/auth'
      }).then(response => response.accessToken);
    } catch (error) {
      console.error("Teams desktop auth failed:", error);
      throw error;
    }
  };

  // Helper function to wait for ongoing interaction to complete
const waitForInteractionToComplete = async (instance, timeout) => {
  const start = Date.now();
  while (instance.getAllAccounts().length === 0 && Date.now() - start < timeout) {
    await new Promise(resolve => setTimeout(resolve, 100));
  }
};
 
  const sendMessage = async (chatId, tabsAppDeepLink, accessToken) => {
    try {

      const response = await fetch(
        `https://graph.microsoft.com/v1.0/chats/${chatId}/messages`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        
          body: JSON.stringify({
            body: {
              content: `Hello <at id="0">everyone</at>! <attachment id="1"></attachment>`, // Fallback text if Adaptive Cards are not supported
              contentType: "html", // Use "html" to support rich formatting
            },
            mentions: [
              {
                id: 0,
                mentionText: "everyone",
                mentioned: {
                  conversation: { id: chatId },
                },
              }
            ],
            importance: "urgent",
            attachments: [
              {
                id:"1",
                contentType: "application/vnd.microsoft.card.adaptive",
                content: JSON.stringify({
                  type: "AdaptiveCard",
                  version: "1.4",
                  body: [
                    // {
                    //   type: "TextBlock",
                    //   text: "Your Donation form has been published, Please Click on Givent tab added in the meeting to start your donation.",
                    //   wrap: true,
                    // },
                    {
                    type: "TextBlock",
                    text: "🎉 Your donation form is ready!",
                    wrap: true,
                    weight: "Bolder",
                    size: "Large"
                  },
                  {
                    type: "TextBlock",
                    text: "Go to your meeting and click on the **Givent tab** (in the meeting tabs/content bar) from the top bar to start your donation.",
                    wrap: true,
                    spacing: "Medium"
                  }
                  ],
                  // actions: [
                  //   {
                  //     type: "Action.OpenUrl",
                  //     title: "Givent",
                  //     url: tabsAppDeepLink, // Your deep link here
                  //   },
                  // ],
                }),
              },
            ],
          }),
        }
      );

      if (response.ok) {
        console.log("Message sent successfully!",await response.json());
        setInvitationOpen(false);
          setFormPublished(true);
         setWaitForForm(false);
          navigate("/loadform",{ state: { showDForm: true } });
          setShowLoader(false);
          localStorage.removeItem('chatId'); // Clear chatId after use
      } else {
        const error = await response.json();
        console.error("Error sending message:", error);
      }
    } catch (error) {
      console.error("Error acquiring token or sending message:", error);
    }
  };
 
  return (
    <>
      <div className="recurring_transaction_container">
        <div className="recurring_transaction_wrapper">
          <div className="recurring_transaction_card mt_2">
            <div className="recurring_transaction_card_header">
              <div className="transaction_info_logo_container">
             
                {!formSettings.FormHeader ? (
                        <img src={`images/givent_logo_1.png?${(new Date()).getTime()}`} alt="Click and Pledge" />
                      ):(
                        <div className="header-name">{formSettings.FormHeader}</div>
                      )}
              </div>

              {formpublished && !invitationerror && (
                <AlertMsg
                  message="Form Published Successfully! Please wait your form is loading..."
                  type="success"
                  isClose={false}
                />
              )}
              {invitationerror && (
                <>
                 <AlertMsg
                 message="Send Invitation timeout! Please reload your app again."
                 type="failure"
                 isClose={true}
               />
               <p onClick={reLoad} style={{color:'blue', cursor:'pointer'}}>Reload</p>
               </>
              )}
              {showLoader && (
                <div className="loader-container">
                 <div className="lds-ellipsis">
                 <div></div>
                 <div></div>
                 <div></div>
                 <div></div>
               </div>
               </div>
              )}
           
            </div>
            <div className="recurring_transaction_card_body">
            
              <div className="form_input_wrapper d-flex justify-content-between mt_1">
                <button
                  className="full_button tabindex_btn next"
                  type="button"
                  data-index="0"
                  onClick={publish}
                  disabled={formpublished || showLoader || waitforform}
                  style={{marginBottom:'20px'}}
                >
                  {!showLoader && !waitforform ? (
                    <>
                      <span className="">Publish & Broadcast</span>
                    </>
                  ) : (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      <span className="">Loading...</span>{" "}
                    </>
                  )}
                </button>
              </div>
              {/* {error1 && (
                <AlertMsg
                  message={"Error1: " + error1}
                  type="failure"
                  isClose={true}
                  onClose={() => setError1("")}
                />
              )} */}
              {/* {error2 && (
                <AlertMsg
                  message={"Error2: " + error2}
                  type="failure"
                  isClose={true}
                  onClose={() => setError2("")}
                />
              )} */}
              
              {/* {error3 && (
                <AlertMsg
                  message={"Error3: " + error3}
                  type="failure"
                  isClose={true}
                  onClose={() => setError3("")}
                />
              )} */}
              {/* {isObocalled && "IsOBO: " + isObocalled} */}
              {/* {teamsToken && "Teams Token: " + teamsToken} */}

            </div>
            <FooterSecuredBy />
          </div>
        </div>
      </div>
    </>
  );
};

export default PublishForm;
